import assign from 'object-assign';
import $ from '@modules/jquery-import';
import {makeCopy} from '@util/ObjectUtils';

var Corpus = window.Corpus = {

    name: 'Corpus',

    version: '0.0.1',

    namespace: function ( ns_str, scope ) {
        var parts = ns_str.split( '.' ),
            parent = scope || upi,
            i = 0,
            l;

        // filter redundant ns global
        if ( parts[i] === 'Corpus' ) {
            parts = parts.slice( 1 );
        }

        for ( i, l = parts.length; i < l; i++ ) {
            // create ns if not exists
            if ( typeof parent[parts[i]] === 'undefined' ) {
                parent[parts[i]] = {};
            }
            parent = parent[parts[i]];
        }

        return parent;
    },

    modules: {},

    init: function ( scope, modules, options ) {
        // console.log( 'init:', arguments );
        var module_arr,
            module_paths,
            initialized_modules = [],
            args = [scope, options];

        this.scope = scope || this.scope;
        // cleanup optional params

        if ( modules && typeof modules === 'string' ) {

            // allow modules to be destroyed globally
            if ( /off/i.test( modules ) ) {
                // dismantel all modules
                return this.destroy();
            }

            module_arr = modules.split( ' ' );

            if ( module_arr.length > 0 ) {
                module_arr.forEach( function ( module ) {
                    initialized_modules.push( this.init_module( module, args ) );
                }.bind( this ) );
            }
        }

    },

    destroy: function () {
        // remove all attached events for this scope
        // todo: iterate over all initialized modules and invoke their .off method
        for ( var module in this.modules ) {
            if ( this.modules.hasOwnProperty( module )
                && typeof this.modules[module].off === 'function' ) {
                this.modules[module].off( this.scope );
            }
        }

        $( this.scope ).off( '.corpus' );
        $( window ).off( '.corpus' );
        return true;
    },

    create: function ( scope, module, options ) {
        //                        console.log( 'initialized %s', this.name, arguments );
        var self = this;
        $( scope ).find( '[data-' + module + ']' ).each( function ( index, el ) {
            // create a scoped instance for initialization
            var scoped_module = Object.create( module );

            // merge options with a copy of default settings so scoped modules can be configured independently
            scoped_module.init( el, $.extend( true, makeCopy( options ), options ) );

        }.bind( this ) );

        return this;
    },

    _settings: {},

    setup: function ( options ) {
        assign( this._settings, options || {} );
    },

    getGlobalOptions: function ( moduleName ) {
        return makeCopy( this._settings[moduleName] || {} );
    },

    // execute the modules initializer, passing this.scope and settings provided
    init_module: function ( module, args ) {
        return this.trap( function () {
            if ( this.modules.hasOwnProperty( module ) ) {
                var mod = this.modules[module];
                return mod.init.apply( mod, args );
            }
        }.bind( this ), module );
    },

    /**
     * parse serialized string to object notation in the form "key:value, key:value"
     * @param str
     * @returns {{}}
     */
    parse_options: function ( str ) {
        var options = {},
            options_arr;

        if ( typeof str !== 'string' || !str ) {
            return options;
        }
        options_arr = str.split( ',' );
        options_arr.forEach( function ( item ) {
            var key = item.split( ':' );
            options[key[0].replace( '-', '_' )] = key[1];
        } );

        return options;
    },

    trap: function ( fn, module ) {
        // try to initialize modules, handle exceptions that may occur
        try {
            return fn();
        }
        catch ( e ) {
            return this.error( {
                name: module,
                message: 'failed to initialize',
                more: [e.name, e.message].join( ' ' )
            } );
        }
    },

    // format
    error: function ( err ) {
        console.error( err.name, err.more );
        return err.name + ' ' + err.message + '; ' + err.more;
    }

};

// attach Corpus to the global library object
$.fn.corpus = function () {
    var args = Array.prototype.slice.call( arguments );
    return this.each( function () {
        Corpus.init.apply( Corpus, [this].concat( args ) );
    } );
};

export default Corpus;
